"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDebug = exports.clientDebugOptions = exports.serverDebugOptions = void 0;
const constants_1 = __importDefault(require("../shared/constants"));
const create_1 = require("./create");
exports.serverDebugOptions = {
    collisionDraw: false,
    collisionBodies: { circles: [], polygons: [] }
};
exports.clientDebugOptions = {
    collisionDraw: false,
    collisionBodies: { circles: [], polygons: [] }
};
function updateDebug(systemArray, debugOptions, color, lineWidth = 2, updatePoints = false) {
    if (debugOptions.collisionDraw) {
        debugOptions.collisionBodies.circles.forEach(body => {
            body.destroy();
        });
        debugOptions.collisionBodies.polygons.forEach(body => {
            body.destroy();
        });
        debugOptions.collisionBodies.circles.length = 0;
        debugOptions.collisionBodies.polygons.length = 0;
        systemArray.circles.forEach(body => {
            const newBody = create_1.phaserObject.add.circle(body.x, body.y, body.r);
            newBody.setStrokeStyle(lineWidth, color);
            newBody.setDepth(constants_1.default.DEPTHS.debug);
            debugOptions.collisionBodies.circles.push(newBody);
        });
        systemArray.polygons.forEach(body => {
            // if (updatePoints) {
            let bodyPoints = [];
            body.points.forEach(point => {
                if (updatePoints) {
                    bodyPoints.push({ x: point.x + body.centroid.x, y: point.y - body.centroid.y });
                }
                else {
                    bodyPoints.push({ x: point.x + body.centroid.x, y: point.y + body.centroid.y });
                }
            });
            // }
            const newBody = create_1.phaserObject.add.polygon(body.x, body.y, bodyPoints);
            newBody.rotation = body.angle;
            newBody.setStrokeStyle(lineWidth, color);
            newBody.setDepth(constants_1.default.DEPTHS.debug);
            debugOptions.collisionBodies.polygons.push(newBody);
        });
    }
    else {
        if (debugOptions.collisionBodies.circles.length > 0) {
            debugOptions.collisionBodies.circles.forEach(body => {
                body.destroy();
            });
        }
        if (debugOptions.collisionBodies.polygons.length > 0) {
            debugOptions.collisionBodies.polygons.forEach(body => {
                body.destroy();
            });
        }
    }
}
exports.updateDebug = updateDebug;
